import { DEFAULT_WAREHOUSE_ID } from 'commons/constants';
import { IN_STOCK_WAREHOUSE_FIELD } from './categoryPageTypes';

/**
 * Ready-to-ship toggle clause. Cart and PDP treat stock at the zip warehouse
 * or the default DC (`154`) as ready-to-ship, so the listing matches that
 * union. Without a zip there is no warehouse to scope by — fall back to the
 * record-level flag rather than pretending the user is at `154`.
 */
export const buildInStockWarehouseFilterClause = ({
  warehouseId,
  hasUserZip,
  field = IN_STOCK_WAREHOUSE_FIELD,
} = {}) => {
  if (!hasUserZip) {
    return 'is_in_stock:true';
  }

  const resolvedWarehouseId = warehouseId || DEFAULT_WAREHOUSE_ID;
  const warehouseClause = `product_variants.${field}:${resolvedWarehouseId}`;

  if (String(resolvedWarehouseId) === String(DEFAULT_WAREHOUSE_ID)) {
    return warehouseClause;
  }

  return `(${warehouseClause} OR product_variants.${field}:${DEFAULT_WAREHOUSE_ID})`;
};
